/**
 * @param {string} key
 * @return {object|null}
 */
export const getItem = (key) => {
  const item = window.localStorage.getItem(key);
  if (!item || item === 'undefined') {
    return null;
  }

  return JSON.parse(item);
};

/**
 * @param {string} key
 * @param {object} value
 * @return {void}
 */
export const setItem = (key, value) => {
  const stringValue = JSON.stringify(value);
  window.localStorage.setItem(key, stringValue);
};
